export default function isOffline() {
	// eslint-disable-next-line no-undef
	return process.env.VUE_APP_TMSLITE_OFFLINE === 1;
}
